import { WholeOrFixed } from '@ts/currency/WholeOrFixed';

export default function priceFormatterKey(
  locale: string,
  wholeOrFixed: WholeOrFixed,
): string {
  return `${wholeOrFixed}~${locale}`;
}
